import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Briefcase, Code } from 'lucide-react';
import TabComponent from '../copilot/TabComponent';
import CodingComponent from '../coding/CodingComponent';
import './DemoTabs.css';

const DemoTabs = ({ variant = 'default' }) => {
    const [activeTab, setActiveTab] = useState('non-coding');
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const target = pathname + hash;
        if (target.includes('coding-assistant')) {
            setActiveTab('coding');
        } else if (target.includes('interview-copilot') || target.includes('demo')) {
            setActiveTab('non-coding');
        }
    }, [pathname, hash]);

    return (
        <div className="demo-tabs">
            <h2 className="visually-hidden">
                {variant === 'assistant'
                    ? 'AI Assistant & Coding Assistant Demo'
                    : 'Interview Copilot & Coding Assistant Demo'}
            </h2>
            <div className="demo-tabs__switcher" role="tablist" aria-label="Demo type">
                <button
                    className={`demo-tabs__tab ${activeTab === 'non-coding' ? 'active' : ''}`}
                    onClick={() => setActiveTab('non-coding')}
                    role="tab"
                    aria-selected={activeTab === 'non-coding'}
                >
                    <Briefcase size={16} />
                    Non-Coding
                </button>
                <button
                    className={`demo-tabs__tab ${activeTab === 'coding' ? 'active' : ''}`}
                    onClick={() => setActiveTab('coding')}
                    role="tab"
                    aria-selected={activeTab === 'coding'}
                >
                    <Code size={16} />
                    Coding
                </button>
            </div>

            {activeTab === 'non-coding' ? (
                <div className="demo-tabs__panel" role="tabpanel">
                    <div className="demo-container">
                        <TabComponent variant={variant} />
                    </div>
                </div>
            ) : (
                <div className="demo-tabs__panel" role="tabpanel">
                    <div className="demo-container">
                        <CodingComponent />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DemoTabs;
